import { useNavigate } from "react-router-dom";
import TableFilter from "./tableFilter";
import { useEffect } from "react";

function ManagementTeam() {
  const navigate = useNavigate();

  return (
    <>
      <div className="content-wrapper">
        <div
          className="content-heading d-flex
                          justify-content-between"
        >
          <div>Management</div>
        </div>
        <TableFilter />
      </div>
    </>
  );
}

export default ManagementTeam;
